import React from 'react'
import './LanguageButton.css'

function LanguageButton({ link, text, title }) {
  return (
    <div 
      className="language-button" 
      onClick={() => window.location.href = link}
      title={title}
    >
      <span>{text}</span> 
    </div>
  )
}

export default LanguageButton
